export default __webpack_public_path__ + "68fb52926a364256fda24ac20e89c490.png";